import { useLayoutEffect, useMemo, createContext, useContext } from 'react';
import ReactDom from 'react-dom';
import { PopupsContext } from '../../utils';
export var ModalContext = createContext({});
export var Modal = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, className = _a.className, applicationRootElement = _a.applicationRootElement, children = _a.children;
    var _c = useContext(ModalContext), contextAppElementID = _c.applicationElementId, modalElementID = _c.modalElementID;
    var _d = useContext(PopupsContext), baseContextAppElementID = _d.applicationElementID, rootElement = _d.rootElement;
    var appElementID = applicationRootElement ||
        contextAppElementID ||
        baseContextAppElementID ||
        'root';
    var target = rootElement || document.getElementById(appElementID);
    if (!target)
        throw new Error("Application root element with ID \"" + appElementID + "\" not found");
    var div = useMemo(function () {
        var element = document.createElement('div');
        element.className += className;
        if (modalElementID)
            element.id += modalElementID;
        return element;
    }, []);
    useLayoutEffect(function () {
        if (open) {
            target === null || target === void 0 ? void 0 : target.appendChild(div);
            return function () {
                target === null || target === void 0 ? void 0 : target.removeChild(div);
            };
        }
        return void 0;
    }, [open]);
    if (!open) {
        return null;
    }
    return ReactDom.createPortal(children, div);
};
